<div class="flex flex-col w-full overflow-auto lg:overflow-hidden items-center py-4 gap-8 h-full">
  <div class="flex flex-col gap-4 w-full px-4 max-w-lifemap">
    <h1>{{ 'profile.weekly_lifeacts.title' | translate }}</h1>
    <p class="text-lg">
      {{ 'profile.weekly_lifeacts.intro' | translate }}
    </p>
  </div>

  <div class="flex grow overflow-visible lg:overflow-hidden w-full max-w-lifemap">
    <div class="flex flex-col w-full lg:flex-none lg:w-[440px]">
      <div class="px-4 border-b border-b-pl-gray-400 min-h-[70px] flex items-center">
        <h3>{{ 'profile.weekly_lifeacts.levels_modules' | translate }}</h3>
      </div>
      <div class="flex grow overflow-visible lg:overflow-hidden">
        <pl-my-life-acts-menu
          *ngIf="!userIsOnSmallScreen() || participantHasUnlockAtLeastOneLifeActStep()"
          class="block overflow-visible lg:overflow-auto p-4 grow"
          [menu]="lifeActMenu()"
          [currentlySelectedLifeactStepFullUrl]="lifeactStepSelectedFullUrl()"
          (moduleClicked)="displayLifeActStep($event)"
        />

        <div
          *ngIf="userIsOnSmallScreen() && !participantHasUnlockAtLeastOneLifeActStep()"
          class="h-full flex grow items-center justify-center"
        >
          <ng-container *ngTemplateOutlet="noLifeactUnlockedYet" />
        </div>
      </div>
    </div>

    <div class="grow flex-col min-w-0 hidden lg:flex">
      <div class="px-4 border-b border-b-pl-gray-400 min-h-[70px] flex items-center justify-between">
        <h3>{{ 'profile.weekly_lifeacts.my_lifeacts' | translate }}</h3>
        <pl-my-life-acts-download-button
          *ngIf="currentlySelectedLifeactStepData()"
          [lifeactStepData]="currentlySelectedLifeactStepData()"
        />
      </div>
      <div class="flex flex-col justify-center items-center overflow-hidden h-full border-l border-l-pl-orange-800">
        <pl-loader *ngIf="stepDataRetrieveInProgress()" />
        <pl-my-life-acts-blocks
          *ngIf="participantHasUnlockAtLeastOneLifeActStep() && !stepDataRetrieveInProgress()"
          class="overflow-auto h-full w-full px-4"
          [lifeactStepData]="currentlySelectedLifeactStepData()"
        />

        <div *ngIf="!participantHasUnlockAtLeastOneLifeActStep()">
          <ng-container *ngTemplateOutlet="noLifeactUnlockedYet" />
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #noLifeactUnlockedYet>
  <div class="flex flex-col items-center gap-4 py-4 max-w-[400px]">
    <p class="text-lg text-center font-bold">
      {{ 'profile.weekly_lifeacts.no_lifeact_step_unlocked' | translate }}
    </p>
    <pl-button [variant]="ButtonVariant.orange" class="!w-fit" (click)="goToCurrentStep()">
      {{ 'profile.weekly_lifeacts.go_to_current_step' | translate }}
    </pl-button>
  </div>
</ng-template>
